import * as texts from "./locales";

const generateFields = ({
  freire,
  companyOptions,
  onChangeCompany,
  stationOptions,
  onChangeShowZeroCharges,
  hasPermission,
}) => [
  ...(!hasPermission("charger-history-hide-companies-filter")
    ? [
        {
          label: "Empresas",
          name: "company_ids",
          component: "tupi.select",
          isMultiple: true,
          placeholder: freire(texts.SELECT_COMPANIES),
          options: companyOptions,
          onChange: onChangeCompany,
          colSpan: 8,
        },
      ]
    : []),
  ...(!hasPermission("charger-history-hide-stations-filter")
    ? [
        {
          label: "Estações",
          name: "station_ids",
          component: "tupi.select",
          isMultiple: true,
          placeholder: freire(texts.SELECT_STATIONS),
          options: stationOptions,
          colSpan: 8,
          help: freire(texts.SELECT_STATIONS_HELP),
        },
      ]
    : []),
  {
    label: "Período",
    name: "dateTime",
    component: "rangePicker",
    locale: "pt_BR",
    placeholder: [freire(texts.INITIAL_DATE), freire(texts.FINAL_DATE)],
    colSpan: 7,
  },
  {
    name: "dropdown_menu_config",
    component: "tupi.dropdown-menu",
    colSpan: 1,
    items: [
      {
        label: freire(texts.SHOW_ZERO_CHARGES),
        component: "tupi.switch",
        name: "show_zero_charges",
        onChange: onChangeShowZeroCharges,
      },
    ],
  },
];

export default generateFields;
